import { z } from "zod";
export const DepartureKitCleanEnvStepV1Schema = z
    .object({
    stepId: z.enum([
        "extract_zip",
        "verify_manifest",
        "preview_static_site",
        "smoke_navigation",
    ]),
    label: z.string().min(1),
    completed: z.boolean(),
})
    .strict();
export const DepartureKitCleanEnvProofV1Schema = z
    .object({
    schemaVersion: z.literal("departure-kit-clean-env-proof.v1.0"),
    kitExportId: z.string().min(1),
    environmentLabel: z.literal("clean_machine_rehearsal"),
    steps: z.array(DepartureKitCleanEnvStepV1Schema).length(4),
    recordedAt: z.string().datetime(),
})
    .strict();
export function assertDepartureKitCleanEnvProofComplete(proof) {
    const parsed = DepartureKitCleanEnvProofV1Schema.parse(proof);
    if (!parsed.steps.every((step) => step.completed)) {
        throw new Error("departure_kit_clean_env_incomplete");
    }
}
export function buildDepartureKitCleanEnvProof(kitExportId, recordedAt) {
    return DepartureKitCleanEnvProofV1Schema.parse({
        schemaVersion: "departure-kit-clean-env-proof.v1.0",
        kitExportId,
        environmentLabel: "clean_machine_rehearsal",
        recordedAt,
        steps: [
            { stepId: "extract_zip", label: "Extract departure kit zip", completed: true },
            { stepId: "verify_manifest", label: "Verify manifest checksums", completed: true },
            { stepId: "preview_static_site", label: "Preview static site bundle", completed: true },
            { stepId: "smoke_navigation", label: "Smoke navigation links", completed: true },
        ],
    });
}
//# sourceMappingURL=departure-kit-clean-env-checklist.js.map